import { render, staticRenderFns } from "./PriceInquiry.vue?vue&type=template&id=5f8afa86&"
import script from "./PriceInquiry.vue?vue&type=script&lang=js&"
export * from "./PriceInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports